import { QueryKeysEnum } from '@/enums';
import { streamAnalysisSampleKitsEventName } from '@/pages/authenPages/Analysis/commercial-analysis';
import {
  AnalysisSampleKitEntity,
  AnalysisSampleKitParam,
  CreateCommercialSampleKitEntity,
} from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';
import { FileData } from '@/interfaces';
import { streamDownloadSampleKitReports } from '@/pages/authenPages/Analysis/commercial-analysis/sections/DownloadSampleKitDropdown';

class AnalysisSampleKitService extends BaseService<
  'analysisSampleKit',
  AnalysisSampleKitEntity,
  CreateCommercialSampleKitEntity
> {
  constructor() {
    super(QueryKeysEnum.ANALYSIS_SAMPLE_KIT);
  }

  getAllAnalysisSampleKits = (params: AnalysisSampleKitParam): Promise<any> => {
    return APIService.get(this.path + '/stream-all', {
      params,
      responseType: 'stream',
      onDownloadProgress(data) {
        const responseData = data.event?.target?.response || '';
        // Regex to find all progress values
        const regex = /"progress"\s*:\s*(\d+(\.\d+)?)/g;
        const matches = [...responseData.matchAll(regex)];
        // Get the last match
        const lastMatch = matches[matches.length - 1];
        const lastProgress = lastMatch
          ? Math.round(parseFloat(lastMatch[1]))
          : 0;

        // Dispatch kit quantity for percent progress bar
        window.dispatchEvent(
          new CustomEvent(streamAnalysisSampleKitsEventName, {
            detail: { percentProgress: lastProgress },
          }),
        );
      },
    });
  };

  downloadSampleKitReport = (sampleKitId: string): Promise<FileData[]> => {
    return APIService.get(this.path + `/${sampleKitId}/presigned-reports`);
  };

  downloadAllSampleKitReports = (payload: {
    analysisBatchId?: string;
    kitIds?: string[];
  }): Promise<any> => {
    const { analysisBatchId, ...rest } = payload;

    return APIService.get(this.path + '/stream-presigned-reports', {
      params: { displayId: analysisBatchId, ...rest },
      responseType: 'stream',
      onDownloadProgress(data) {
        const responseData = data.event?.target?.response || '';
        // Regex to find all progress values
        const regex = /"progress"\s*:\s*(\d+(\.\d+)?)/g;
        const matches = [...responseData.matchAll(regex)];
        // Get the last match
        const lastMatch = matches[matches.length - 1];
        const lastProgress = lastMatch
          ? Math.round(parseFloat(lastMatch[1]))
          : 0;

        // Dispatch kit quantity for percent progress bar
        window.dispatchEvent(
          new CustomEvent(streamDownloadSampleKitReports, {
            detail: {
              percentProgress: lastProgress === 100 ? 99 : lastProgress,
            },
          }),
        );
      },
    });
  };

  updatePipelineSettings = (
    payload: Partial<AnalysisSampleKitEntity>,
  ): Promise<AnalysisSampleKitEntity> => {
    const { id, ...rest } = payload;
    return APIService.patch(this.path + '/' + id + '/pipeline-settings', rest);
  };
}
export const analysisSampleKitService = new AnalysisSampleKitService();
